import { bindActionCreators } from 'redux'
import * as userInfoAction from './modules/userInfo'
import * as chatAction from './modules/chatInfo'
import * as commentAction from './modules/commentInfo'
import * as errorStateAction from './modules/errorStateInfo'
import * as userPermissionAction from './modules/userPermission'
import * as footerStateInfoAction from './modules/footerStateInfo'
import * as bankAccountStateInfoAction from './modules/bankAccountInfo'
import * as productDetailInfoAction from './modules/productDetailInfo'
import * as eventModalAction from './modules/eventModal'

import store from './index'

const { dispatch } = store

export const UserInfoActions = bindActionCreators(userInfoAction, dispatch)
export const UserPermissionActions = bindActionCreators(userPermissionAction, dispatch)
export const ChatActions = bindActionCreators(chatAction, dispatch)
export const CommentActions = bindActionCreators(commentAction, dispatch)
export const ErrorStateActions = bindActionCreators(errorStateAction, dispatch)
export const FooterStateActions = bindActionCreators(footerStateInfoAction, dispatch)
export const BankAccountStateActions = bindActionCreators(bankAccountStateInfoAction, dispatch)
export const ProductDetailInfoActions = bindActionCreators(productDetailInfoAction, dispatch)
export const EventModalActions = bindActionCreators(eventModalAction, dispatch)
